import * as React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";

class OurStepManager extends React.Component {

    constructor(props) {
        super(props);
        this.renderSteps = this.renderSteps.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);        
        this.getClassName = this.getClassName.bind(this);
        this.callGoBack = this.callGoBack.bind(this);
        this.refresh = this.refresh.bind(this);

        let statuses = ['doing'];
        for (let i = 1; i < this.props.children.length; i++) {
            statuses.push("todo");
        }

        this.state = {
            currentStep: (this.props.startingStep ? this.props.startingStep : 0),
            mounted: false,
            baseURL: window.location.pathname,
            stepStatuses: statuses,
            stepsStatusList: statuses
        };

        // Here we repack our children into collections we can touch (with references)
        //this.referenceCollection = [];
        //this.childCollection = [];

    }

    componentWillMount() {
        this.setState({ mounted: true });
    }

    componentDidMount() {
        this.routerListener = this.props.history.listen((location, action) => {
            console.log(action, location.pathname, location.state);                     
            // location is an object like window.location
            if (location.pathname === this.state.baseURL) {
                let sStep = location.search.replace("?s=", "");
                let iStep = parseInt("0" + sStep);                
                if (iStep !== this.state.currentStep) {                    
                    if (iStep < this.state.currentStep)                       
                        this.goBack(iStep, false); 
                    else
                        this.goNext(false); 
                }
                 }
        });
    }

    componentWillUnmount() {
        if (this.routerListener) {
            this.routerListener();
            this.routerListener = null;
        }
        this.setState({ mounted: true });
    }

    referenceCollection = [];
    childCollection = [];

    callGoBack(targetStep) {
        const { currentStep } = this.state;
        if (targetStep < currentStep) {
            if (this.props.onBack) {
                this.props.onBack(this, this.referenceCollection[currentStep]);
            }
        } else if (targetStep > currentStep) {
            if (this.props.onForward) {
                this.props.onForward(this, this.referenceCollection[currentStep]);
            }
        }
        this.updateStepStatusOnGoBackForward(targetStep);
    }

    //Handle the flow representation for the progress while click back button
    updateStepStatusOnGoBackForward(targetStep) {
        let newStatuses = this.state.stepStatuses;
        if (this.referenceCollection && newStatuses) {
            for (let i = 0; i < this.referenceCollection.length; i++) {
                if (i > targetStep)
                    newStatuses[i] = "todo";
                else if (i === targetStep)
                    newStatuses[i] = "doing";
            }
            this.setState({ stepStatuses: newStatuses, stepsStatusList: newStatuses });
        }
    }


    // handles keydown on enter being pressed in any Child component input area. in this case it goes to the next (ignore textareas as they should allow line breaks)
    handleKeyDown(evt) {
        if (evt.which === 13) {
            if (evt.target.type !== 'textarea') {
                evt.preventDefault();
            } else if (!this.props.preventEnterSubmission && evt.target.type !== 'textarea') {
                this.goNext();
            }
        }
    }

    getDoingStatus(status) {
        return status === 'todo' ? 'doing' : 'doingdid';
    }

    getFutureStatus(status) {
        return status === 'done' || status === 'doingdid' ? 'futuredone' : 'todo';
    }

    getCurrentInstance(step) {        
        const currentComponent = this.referenceCollection[step];
        let currentInstance = currentComponent ? currentComponent.current : null;

        if (currentInstance && currentInstance.getWrappedInstance) {
            currentInstance = currentInstance.getWrappedInstance();
        }

        return currentInstance;
    }

    goNext = (canPush = true) => {
        let { currentStep, stepsStatusList } = this.state;
        const currentInstance = this.getCurrentInstance(currentStep);
        let success = true;

        if (currentInstance && currentInstance.isValid) {
            success = currentInstance.isValid();
        }

        if (success) {
            stepsStatusList[currentStep] = 'done';
            if (currentStep < stepsStatusList.length - 1) {
                currentStep++;
                stepsStatusList[currentStep] = this.getDoingStatus(stepsStatusList[currentStep]); // update next step, which should be newStep
            }
        }
        else {
            stepsStatusList[currentStep] = 'doing';
        }

        this.setState({ stepsStatusList, currentStep }, () => {
            if (canPush) {
                if (this.state.baseURL)
                    this.props.history.push(this.state.baseURL + "?s=" + currentStep);
            }
            if (currentInstance && currentInstance.onGoNext) {
                currentInstance.onGoNext(success);
            }
            if (this.props.onStepChange) {
                this.props.onStepChange(success, currentStep);
            }
        });
    }

    //This function build for just skip the step if its already we consider valid. We are not doing any comp validating check here.
    goToNewStep = (canPush = true, newStep) => {
        let { currentStep, stepsStatusList } = this.state;
        const currentInstance = this.getCurrentInstance(currentStep);
        if (newStep === currentStep) {
            return; // do nothing as this is an illegal step change
        }
        for (let i = 0; i < stepsStatusList.length; i++) {
            if (newStep > i) {
                stepsStatusList[i] = 'done';
            }
        }
        if (currentStep < stepsStatusList.length - 1) {
            currentStep = newStep;
            stepsStatusList[currentStep] = this.getDoingStatus(stepsStatusList[currentStep]); // update next step, which should be newStep
        }
        this.setState({ stepsStatusList, currentStep }, () => {
            if (canPush) {
                if (this.state.baseURL)
                    this.props.history.push(this.state.baseURL + "?s=" + currentStep);
            }
            if (currentInstance && currentInstance.onGoNext) {
                currentInstance.onGoNext(true);
            }
            if (this.props.onStepChange) {
                this.props.onStepChange(true, currentStep);
            }
        });
    }

    goBack = (newStep, canPush = true) => {
        const { currentStep, stepsStatusList } = this.state;

        if (newStep >= currentStep) {
            return; // do nothing as this is an illegal step change
        }

        stepsStatusList[newStep] = this.getDoingStatus(stepsStatusList[newStep]);
        for (let i = newStep + 1; i <= currentStep; i++) {
            stepsStatusList[i] = this.getFutureStatus(stepsStatusList[i]);
        }
        
        this.setState({ stepsStatusList, currentStep: newStep }, () => {
            if (canPush) {
                if (this.state.baseURL)
                    this.props.history.push(this.state.baseURL + "?s=" + newStep);
           }
            const currentInstance = this.getCurrentInstance(currentStep);
            if (currentInstance && currentInstance.onGoBack) {
                currentInstance.onGoBack(newStep);
            }
            if (this.props.onStepChange) {
                this.props.onStepChange(true, newStep);
            }
        });
    } 

    refresh(index) {
        const { currentStep, stepsStatusList } = this.state;
        if (!index) {
            index = 0;
        }
        for (let i = index; i < stepsStatusList.length; i++) {
            let isValid = false;
            const currentInstance = this.getCurrentInstance(i);
            if (currentInstance && currentInstance.isValid) {
                isValid = currentInstance.isValid();
            }
            if (i < currentStep) {
                stepsStatusList[i] = isValid ? 'done' : 'todo';
            }
            else if (i === currentStep) {
                stepsStatusList[i] = isValid ? 'doingdid' : 'doing';
            }
            else {
                stepsStatusList[i] = isValid ? 'futuredone' : 'todo';
            }
        }
        this.setState({ stepsStatusList });
    }

    // get the classmame of steps
    getClassName(className, i) {       
        const { currentStep } = this.state;
        const step = this.referenceCollection[currentStep];
        let isValid = false;
        //debugger;

        if (step && step.current && step.current.isValid) {
            isValid = step.current.isValid();
        }


        const { stepStatuses, stepsStatusList } = this.state;

        let status = "todo";
        if (stepsStatusList && stepsStatusList.length > i) {
            status = stepsStatusList[i];
        }
        //if (stepStatuses)
        //{
        //    status = stepStatuses[i];
        //}
        //debugger;

        //if (i < currentStep) {
        //    status = "done";
        //}
        //else if (i === currentStep && isValid) {
        //    status = "done";
        //}
        //else if (i === currentStep && !isValid) {
        //    status = "doing";
        //}
        //else if (i > currentStep && isValid)
        //{
        //    status = "futuredone";
        //}
        //else {
        //    status = "todo";
        //}

        let liClassName = `${className}-${status}`;

        // if step ui based navigation is disabled, then dont highlight step
        //if (!this.props.stepsNavigation) {
        //    liClassName += ' no-hl';
        //}

        return liClassName;
    }

    // render the steps as stepsNavigation
    renderSteps() {        
        const { showSteps } = this.props;
        if (!showSteps) return;

        return this.childCollection.map((s, i) => {
            //debugger;
            return (
                <li className={this.getClassName('progtrckr', i)} onClick={(evt) => {  this.goBack(i); }} key={i} value={i}>
                    <em>{i + 1}</em>
                    <span>{s.props.steptitle ? s.props.steptitle : "Step " + i}</span>
                </li>
            );
        });
    }

    // main render of stepzilla container
    render() {

        const { currentStep } = this.state;
        const { props } = this;
        let continueButtonText = "Continue";
        let continueButtonStyles = {};
        let bFedUp = this.props.majorFailure; // || this.state.stepStatuses[currentStep] === "doing";
        const { endOnLastStep, backButtonText } = this.props;

        // We repack the children here so that we can style visibility
        this.childCollection = [];
        this.referenceCollection = [];
        let iCurrChild = 0;
        this.props.children.map((child, index) => {
            if (child) {
                let thisRef = React.createRef();
                const cloneExtensions = {                    
                    style: { display: currentStep === iCurrChild ? "block" : "none" },
                    key: iCurrChild,                   
                    goNext: this.goNext,
                    goBack: this.goBack,
                    goToNewStep: this.goToNewStep
                };
                if (child instanceof React.Component
                    || (child.type && child.type.prototype instanceof React.Component)
                    || (child.type && child.type.WrappedComponent && child.type.WrappedComponent.prototype instanceof React.Component)) {
                    cloneExtensions.ref = thisRef;
                    cloneExtensions.stepManager = this;
                }

                let newChild = React.cloneElement(child, cloneExtensions);
                if (iCurrChild === currentStep) {
                    //debugger;
                    if (newChild.props.continueButtonText) {
                        continueButtonText = newChild.props.continueButtonText;
                    }
                    if (newChild.props.shouldHideContinueButton) {
                        continueButtonStyles = { 'display': 'none' };
                    }
                }

                this.childCollection.push(newChild);
                this.referenceCollection.push(thisRef);

                iCurrChild++;
            }

        });
        let bShowNext = ((currentStep < (this.childCollection.length - 1)) && endOnLastStep) || !endOnLastStep;
        let nextBtnStyles = (currentStep === this.childCollection.length) ? { display: 'none' } : continueButtonStyles;
        return (
            <React.Fragment>
                <div className="multi-step" onKeyDown={(evt) => { this.handleKeyDown(evt); }}>
                    <ol className="progtrckr">
                        {this.renderSteps()}
                    </ol> 
                    {this.childCollection}
                    {!bFedUp &&
                        <div style={{}} className="footer-buttons">
                            {currentStep > 0 &&
                                <button
                                    type="button"
                                    style={{}}
                                    className={props.backButtonCls}
                                    onClick={() => { this.goBack(currentStep - 1); }}
                                    id="prev-button"
                                >
                                {backButtonText ? backButtonText : "Back"}
                             </button>
                            }
                            {endOnLastStep}
                            {bShowNext &&
                                <button
                                    ref="btnSubmit"
                                    type="button"
                                    style={nextBtnStyles}
                                    className={props.nextButtonCls}
                                    onClick={() => {  this.goNext(); }}
                                    id="next-button"
                                    disabled={props.disableNextButton}
                                >
                                    {continueButtonText}
                                </button>
                            }
                        </div>
                    }
                </div>
                <div style={{ display: "none" }}>{currentStep}</div>
            </React.Fragment>
        );
    }
}

OurStepManager.defaultProps = {
    showSteps: true,
    showNavigation: true,
    stepsNavigation: true,
    prevBtnOnLastStep: true,
    dontValidate: false,
    preventEnterSubmission: false,
    startAtStep: 0,
    nextButtonText: 'Next',
    nextButtonCls: 'btn btn-prev btn-primary btn-lg pull-right',
    disableNextButton: false,
    backButtonText: 'Previous',
    backButtonCls: 'btn btn-next btn-primary btn-lg pull-left',
    hocValidationAppliedTo: [],   
};

OurStepManager.propTypes = {
    backButtonCls: PropTypes.string,
    backButtonText: PropTypes.string,
    dontValidate: PropTypes.bool,
    nextButtonCls: PropTypes.string,
    disableNextButton: PropTypes.bool,
    nextButtonText: PropTypes.string,    
    onStepChange: PropTypes.func,
    prevBtnOnLastStep: PropTypes.bool,
    preventEnterSubmission: PropTypes.bool,
    showNavigation: PropTypes.bool,
    showSteps: PropTypes.bool, 
    startAtStep: PropTypes.number,  
    stepsNavigation: PropTypes.bool    
};


const mapStateToProps = (state, ownProps) => {
    return {
        history: state.session.history,
        ...ownProps
    };

};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};


export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(OurStepManager);